<template>
  <main class="iphone overflow-hidden">
    <!-- This is only for building the iphone -->
    <section class="speaker absolute top-0 left-1/2 z-1" />

    <!-- This is only for building the iphone -->
    <section class="camera absolute top-0 z-1" />

    <!-- This is where we add the stashboard content -->
    <div class="preview-stashboard-wrapper">
      <stashboard
        :anyLinks='anyLinks'
        :content="stashboard.content"
        :extensionType="mappedExtensionType"
        :merchantName="stashboard.merchantName"
        :merchantWebsiteUrl="stashboard.merchantWebsiteUrl"
        :urlButton="null"
        :stashboardHeaders="transformedStashboardHeaders"
        :stashboardMedia="previewStashboardMedia"
        :isPreview="true"
      />
    </div>

    <!-- This is only for building the iphone -->
    <section class="power-button absolute top-20" />
  </main>
</template>

<script>
import {mapGetters} from "vuex";
import Stashboard from "../../pages/Stashboard/Stashboard.vue";
import "../../../../assets/stylesheets/only_vue/includes/stashboard.css.sass";


export default {
  components: {
    Stashboard,
  },

  props: {
    stashboard: Object,
    previewExtension: Object
  },

  name: "stashboard-preview",

  computed: {
    ...mapGetters([
      "previewStashboardMedia",
    ]),
    mappedExtensionType() {
      let stringType
      switch (this.stashboard.extensionType) {
        case 1:
        case 5:
        case 6:
          stringType = 'track_offer'
          break
        case 3:
          stringType = 'target_wallet'
          break
        case 4:
          stringType = 'any_link'
          break
      }

      return stringType
    },

    transformedStashboardHeaders() {
      // slice here to "unbind" object and prevent infinite re-renders
      return this.stashboard.headers.slice().map(header => { return {...header, image_url: header.attachment.url}});
    },

    anyLinks() {
      if (this.stashboard.extensionType !== 4) return []

      return this.previewExtension?.payload
    }
  },
}
</script>

<style lang="scss" scoped>

.iphone {
  background-color: #fff;
  border-radius: 30px;
  box-shadow: 0px 0px 0px 6px rgb(31, 31, 31),
              -5px -2px 5px 3px rgba(255, 255, 255, .45),
              5px 2px 5px 3px rgba(255, 255, 255, .45),
              0px 0px 0px 15px rgb(17, 17, 17);
  height: 500px;
  position: relative;
  width: 250px;

  .z-1 {
    z-index: 1;
  }

  &:before {
    background-color: rgb(31, 31, 31);
    border-radius: 0px 0px 15px 15px;
    content: "";
    height: 20px;
    left: 50%;
    position: absolute;
    top: 0px;
    transform: translateX(-50%);
    width: 60%;
    z-index: 1;
  }

  .speaker {
    background-color: #101010;
    border-radius: 8px;
    box-shadow: inset 0px -3px 3px 0px rgba(256, 256, 256, 0.2);
    height: 4px;
    transform: translate(-50%, 6px);
    width: 20%;
  }

  .camera {
    background-color: #101010;
    border-radius: 8px;
    box-shadow: inset 0px -3px 2px 0px rgba(256, 256, 256, 0.2);
    height: 8px;
    left: -7%;
    transform: translate(180px, 4px);
    width: 8px;

    &:after {
      background-color: #2d4d76;
      border-radius: 4px;
      box-shadow: inset 0px -2px 2px rgba(0, 0, 0, 0.5);
      content: '';
      display: block;
      height: 6px;
      left: 1px;
      position: absolute;
      top: 2px;
      width: 6px;
    }
  }

  .links-wrapper {
    width: 250px;
  }

  .power-button {
    background-color: #101010;
    border-radius: 8px;
    box-shadow: inset -3px 0px 1px -1px rgba(255, 255, 255, .2);
    height: 50px;
    right: -19px;
    transform: translate(-50%, 0);
    width: 4px;
  }
}

.preview-stashboard-wrapper {
  margin-left: -125px;
  margin-top: -230px;
  position: absolute;
  width: 500px;
  height: 1000px;
  transform: scale(0.5);
  overflow-y: scroll;
}
</style>